module.exports = __webpack_public_path__ + "media/GameplayGGJ.62530102.mp4";